import React from 'react';
import { Row, Col, Label , Collapse, Button } from "reactstrap";
import { formatNullableValue } from '../../../../utils/formatar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {IconeSetaDescer, IconeSetaSubir} from "../../../comum/components/Icones";

export default class CabotagemCard extends React.Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
        this.handleOutrosDadosClick = this.handleOutrosDadosClick.bind(this);
        this.handleClick = this.handleClick.bind(this);

        this.state = {
            outrosDados: false,
            selecionado: this.props.data.marcado
        }
    }

    handleOutrosDadosClick() {
        this.setState(state => ({ outrosDados: !state.outrosDados}));
        if(this.state.outrosDados){
            document.getElementById("icon-geral-fechar" + this.props.id).hidden = true;
            document.getElementById("icon-geral-abrir" + this.props.id).hidden = false;
        }else{
            document.getElementById("icon-geral-abrir" + this.props.id).hidden = true;
            document.getElementById("icon-geral-fechar" + this.props.id).hidden = false;
        }
    }

    handleClick(event) {
        if(this.props.click && !event.target.className.includes("btn")){
            this.setState({
                selecionado: !this.state.selecionado
            },() => {
                this.props.click(this.props.data)
            })
        }
    }

    render() {
        return (
            <Col xs={12} md={6} lg={4} onClick={ this.handleClick }>
                <div className={` card-navio ${this.state.selecionado ? "card-marcado" : ""}`}>
                    <Row>

                        <Col xs={12} className="px-0">
                            <div className="titulo">
                                <Label className="titulo-principal">{ this.props.data[this.props.titulo] }</Label>
                                <Label className="subtitulo">{ this.props.data[this.props.subtitulo] }</Label>
                            </div>
                        </Col>

                        {this.props.colunas.map((col, x) =>
                            (col.dataField !== this.props.titulo) &&
                            (col.dataField !== this.props.subtitulo) &&
                            (col.dataField !== "StatusDsc") &&
                            <Col xs={col.dataField === "acoes" ? 12 : 6} className="px-0" key={x}>
                                {col.dataField !== "botoes"
                                    ? <div className="info bg-cinza">
                                        <div className="titulo">{col.text}</div>
                                        <div className="valor">{col.formatter ?
                                            (
                                                col.formatExtraData ?
                                                    formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data), col, null, col.formatExtraData))
                                                    :
                                                    formatNullableValue(col.formatter(col.dataField.split('.').reduce((o, i) => o[i], this.props.data)))
                                            )
                                            :
                                            formatNullableValue(col.dataField.split('.').reduce((o, i) => o[i], this.props.data))
                                        }</div>
                                    </div>
                                    : <div className="info">
                                        <div className="titulo">{col.text}</div>
                                        <div className="valor">{col.cardFormatter(null, this.props.data)}</div>
                                    </div>
                                }
                            </Col>
                        )}

                        { this.props.data.StatusDsc
                            && <Col xs={12} className="px-0">
                                <div className="info">
                                    <div className={`situacao-btn ${ this.props.data.StatusDsc.toLowerCase() }`}>{ this.props.data.StatusDsc }</div>
                                </div>
                            </Col>
                        }

                        { this.controller.novasCabotagens.length === 0
                            && <Col xs={12}>
                                <div className="area-colapsada">
                                    <Button className="btn" onClick={this.handleOutrosDadosClick} >
                                        Outros dados
                                        <span id={`icon-geral-abrir${ this.props.id }`}><IconeSetaDescer /></span>
                                        <span id={`icon-geral-fechar${ this.props.id }`} hidden ><IconeSetaSubir /></span>
                                    </Button>
                                    <Collapse isOpen={this.state.outrosDados} >

                                        <Row>
                                            { this.props.outrosDados
                                                && this.props.outrosDados.map((col, x) =>
                                                {
                                                    if(col.titulo === 'Movs'){
                                                        return (<Col xs={12} key={x}>
                                                            <div className="card-detalhe">
                                                                <div>
                                                                    <h5>{col.titulo} <FontAwesomeIcon icon="external-link-square-alt" className="card-detalhe--pop-color" size="xs"/></h5>
                                                                    <div className="desc">{ this.props.data[col.field] }</div>

                                                                </div>
                                                            </div>
                                                        </Col>)

                                                    }else{
                                                        return (<Col xs={12} key={x}>
                                                            <div className="card-detalhe">
                                                                <div>
                                                                    <h5>{col.titulo}</h5>
                                                                    <div className="desc">{ this.props.data[col.field] }</div>

                                                                </div>

                                                            </div>
                                                        </Col>)

                                                    }
                                                }

                                            )}
                                        </Row>

                                    </Collapse>

                                </div>
                            </Col>
                        }
                    </Row>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/components/CabotagemCard.js